import apiClient from "./apiClient";

export const resendPasswordSetupEmail = async (userId: string) => {
  return apiClient.post(`v1/users/${userId}/resend-password-setup`);
};

export const forceDeleteUser = async (userId: string) => {
  return apiClient.delete(`v1/users/${userId}?force=true`);
};

export const softDeleteUser = async (userId: string) => {
  return apiClient.delete(`v1/users/${userId}`);
};

export const restoreUser = async (userId: string) => {
  return apiClient.patch(`v1/users/${userId}/restore`);
};
